import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';

import { DiagnosticMessage, DiagnosticMessageEntity } from './types';

export const diagnosticMessageAdapter = createEntityAdapter<DiagnosticMessageEntity>({});

const slice = createSlice({
  name: 'diagnosticMessages',
  initialState: diagnosticMessageAdapter.getInitialState(),
  reducers: {
    addMessage: (state, action: PayloadAction<{ message: DiagnosticMessage }>) => {
      const { message } = action.payload;
      diagnosticMessageAdapter.addOne(state, { ...message, id: v4() });
    },
    removeMessage: (state, action: PayloadAction<{ id: string }>) => {
      const { id } = action.payload;

      if (!state.entities[id]) {
        return;
      }

      diagnosticMessageAdapter.removeOne(state, id);
    },
  },
});

export type State = ReturnType<typeof slice.getInitialState>;
export const initialState = slice.getInitialState();
export const actions = slice.actions;
export default slice.reducer;
